import ReadMoreBlock from './ReadMoreBlock';

export type { ReadMoreBlockProps } from './ReadMoreBlock';

export default ReadMoreBlock;
